import * as constants from '../constants';

export const FORM_VALUES_INITIAL_STATE = {
  name: '',
  description: '',
  tenant_id: '',
  charge_boxs: [],
  dynamic_pricing: {
    enabled: false,
    type: 'station',
    connector1_dynamic_pricing_id: '',
    connector2_dynamic_pricing_id: '',
    connector3_dynamic_pricing_id: ''
  },
  smart_charging: {
    enabled: false,
    start_date: '',
    end_date: '',
    current_nominal_a: '',
    algorithm: '',
    meter_device: {
      device_remote_id: '',
      mac_address: '',
    },
  },
};

const initialState = {
  userPks: [],
  formValues: FORM_VALUES_INITIAL_STATE,
};

export function virtualGroupReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_VIRTUAL_GROUP_FORM_VALUES: {
      return {
        ...state,
        formValues: action.formValues,
      };
    }

    default:
      return state;
  }
}
